
import { christData } from "../lib/data";
import styles from './Christ.module.scss';


const Christ = () => {

    return ( 
        <section >
          
            <div className = {styles.container}> 
                {christData.map(({id, photo}) => (
                    <div className = {styles.container__photo} key={id}> 
                    <img  className={styles.photo} src={photo} alt="крещение фото Ставрополь"/>
                    </div>
                ))}
                   
            </div>
</section>
     );
}
 
export default Christ;